// Sentry bootstrap for the Build Your Book frontend.
// Phase 123 - the SDK (~100 KiB gz) is now a lazy chunk that only
// downloads when REACT_APP_SENTRY_DSN is set. With an empty DSN the
// main bundle carries zero Sentry bytes.
const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();

let _sentry = null;
let _lastUser;

function applyUser(user) {
  if (user && user.user_id) {
    _sentry.setUser({ id: user.user_id, email: user.email || undefined });
  } else {
    _sentry.setUser(null);
  }
}

if (dsn) {
  import(/* webpackChunkName: "sentry" */ '@sentry/react')
    .then((Sentry) => {
      Sentry.init({
        dsn,
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
        release: process.env.REACT_APP_SENTRY_RELEASE || 'buildyourbook@phase28',
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      });
      _sentry = Sentry;
      if (_lastUser !== undefined) applyUser(_lastUser);
    })
    .catch(() => {});
}

export const setSentryUser = (user) => {
  if (!dsn) return;
  _lastUser = user;
  if (_sentry) applyUser(user);
};
